"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMainWrapper = exports.StyledActionButton = exports.StyledActionButtonWrapper = exports.StyledSearchWrapper = exports.StyledActionsWrapper = exports.StyledSelectedOptionsWrapper = exports.StyledWrapper = exports.StyledCheck = exports.StyledChevronDown = exports.StyledOption = exports.StyledValuesName = exports.StyledOptionsWrapper = exports.StyledButton = exports.StyledHint = exports.StyledError = exports.StyledButtonContainer = void 0;
const malty_icons_check_1 = __importDefault(require("@carlsberggroup/malty.icons.check"));
const malty_icons_chevron_down_1 = __importDefault(require("@carlsberggroup/malty.icons.chevron-down"));
const styled_components_1 = __importStar(require("styled-components"));
const Select_types_1 = require("./Select.types");
const fadeIn = (0, styled_components_1.keyframes) `
    0% {opacity: 0;}
    50% {opacity: 0.5;}
    100% {opacity: 1;}
`;
const fadeOut = (0, styled_components_1.keyframes) `
    0% {opacity: 1;}
    100% {opacity: 0;}
`;
exports.StyledButtonContainer = styled_components_1.default.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  position: relative;
  ${({ selectStyle }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      width: fit-content;
      min-width: fit-content;
    `}
`;
exports.StyledError = styled_components_1.default.label `
  font-family: ${({ theme }) => theme.typography.desktop.text.tiny_default['font-family'].value};
  color: ${({ theme }) => theme.colors.colours.system.fail.value};
  font-size: ${({ theme }) => theme.typography.desktop.text.tiny_default['font-size'].value};
  font-weight: bold;
  line-height: ${({ theme }) => theme.typography.desktop.text.tiny_default['line-height'].value};
  letter-spacing: 0;
`;
exports.StyledHint = styled_components_1.default.label `
  font-family: ${({ theme }) => theme.typography.desktop.text.tiny_default['font-family'].value};
  color: ${({ theme }) => theme.colors.colours.support[60].value};
  font-size: ${({ theme }) => theme.typography.desktop.text.tiny_default['font-size'].value};
  font-weight: bold;
  line-height: ${({ theme }) => theme.typography.desktop.text.tiny_default['line-height'].value};
  letter-spacing: 0;
  margin-top: ${({ theme }) => theme.sizes['4xs'].value};
  display: block;
  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
    `}
`;
exports.StyledButton = styled_components_1.default.button `
  text-align: left;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  padding: 0 ${({ theme }) => theme.sizes.s.value};
  height: ${({ height }) => height};
  font-weight: normal;
  font-size: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-size'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['line-height'].value};
  transition-property: border-color, color;
  color: ${({ isActive, theme }) => isActive ? theme.colors.colours.default['digital-black'].value : theme.colors.colours.support[60].value};
  border: 1px solid ${({ theme }) => theme.colors.colours.support[60].value};
  background: ${({ theme }) => theme.colors.colours.default.white.value};
  &:hover,
  &:focus {
    outline: none;
  }
  &:hover {
    border-color: ${({ theme }) => theme.colors.colours.support[60].value};
  }
  &:focus {
    border-color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
    color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
  }
  ${({ selectStyle, theme, open }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      border: 0 transparent;
      background: ${open
        ? theme.colors.colours.overlay['digital-black'][10].value
        : theme.colors.colours.default.white.value};
      width: fit-content;
      padding: 0;
      height: 28px;
      padding: 0 ${theme.sizes.xs.value};
      &:hover {
        background-color: ${theme.colors.colours.overlay['digital-black'][5].value};
      }
    `}

  ${({ isError, theme }) => isError &&
    (0, styled_components_1.css) `
      border: 1px solid ${theme.colors.colours.system.fail.value};
    `}
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  ${({ open }) => open &&
    (0, styled_components_1.css) `
      border-color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
      color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
    `}
  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      border-color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
      color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
      background-color: ${({ theme }) => theme.colors.colours.default.transparent.value} !important;
      &:hover,
      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
      }
    `}
  ${({ readOnly }) => readOnly &&
    (0, styled_components_1.css) `
      pointer-events: none;
      border-color: ${({ theme }) => theme.colors.colours.support[40].value};
      color: ${({ theme }) => theme.colors.colours.support[80].value};
      background-color: ${({ theme }) => theme.colors.colours.support[20].value} !important;
      &:hover,
      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.colours.support[40].value};
      }
    `}
`;
exports.StyledOptionsWrapper = styled_components_1.default.ul `
  position: absolute;
  background-color: ${({ theme }) => theme.colors.colours.default.white.value};
  width: 100%;
  margin-top: 0;
  background: ${({ theme }) => theme.colors.colours.default.white.value};
  overflow-y: auto;
  padding: 0;
  z-index: ${({ zIndex }) => zIndex};
  transform-origin: top center;
  visibility: hidden;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors.colours.default['digital-black'].value};
  animation-name: ${fadeOut};
  opacity: 0;
  transition: all 0.3s ease-in-out;
  max-height: calc(${({ height }) => height} * 7);
  ${({ position }) => position === Select_types_1.SelectPosition.Right &&
    (0, styled_components_1.css) `
      right: 0;
    `}
  ${({ isOpen }) => isOpen &&
    (0, styled_components_1.css) `
      visibility: visible;
      display: block !important;
      animation-name: ${fadeIn};
      animation-duration: 0.3s;
      opacity: 1;
    `}
  ${({ selectStyle }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      width: max-content;
      max-width: 400px;
      min-width: max-content;
    `}
  ${({ selectStyle }) => selectStyle === 'default' &&
    (0, styled_components_1.css) `
      border-top: 0;
    `}
`;
exports.StyledValuesName = styled_components_1.default.div `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
exports.StyledOption = styled_components_1.default.li `
  list-style-type: none;
  cursor: pointer;
  height: ${({ height }) => height};
  font-weight: normal;
  font-family: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-family'].value};
  font-size: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-size'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['line-height'].value};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.sizes.s.value};
  color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
  transition: all 0.3s linear;
  &:hover {
    background-color: ${({ theme }) => theme.colors.colours.support[20].value};
  }
  ${({ selected }) => selected &&
    (0, styled_components_1.css) `
      font-weight: ${({ theme }) => theme.typography.desktop.text['medium-small_bold']['font-weight'].value};
      font-family: ${({ theme }) => theme.typography.desktop.text['medium-small_bold']['font-family'].value};
    `}
  ${({ selectStyle }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      max-width: 400px;
      box-sizing: border-box;
    `}
`;
exports.StyledChevronDown = (0, styled_components_1.default)(malty_icons_chevron_down_1.default) `
  transition: transform 0.2s linear;
  ${({ selectStyle }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      margin-left: ${({ theme }) => theme.sizes.xs.value};
    `}
  ${({ open }) => open &&
    (0, styled_components_1.css) `
      transform: rotate(-180deg);
      transition: transform 0.2s linear;
    `}

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      fill: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
    `}
  ${({ readOnly }) => readOnly &&
    (0, styled_components_1.css) `
      fill: ${({ theme }) => theme.colors.colours.support[80].value};
    `}
`;
exports.StyledCheck = (0, styled_components_1.default)(malty_icons_check_1.default) `
  ${({ selectStyle }) => selectStyle === 'inline' &&
    (0, styled_components_1.css) `
      margin-left: ${({ theme }) => theme.sizes.s.value};
    `}
`;
exports.StyledWrapper = styled_components_1.default.div `
  width: fit-content;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    margin-right: ${({ theme }) => theme.sizes['4xs'].value};
  }
`;
exports.StyledSelectedOptionsWrapper = styled_components_1.default.div `
  font-family: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-family'].value};
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: calc(100% - 36px);
`;
exports.StyledActionsWrapper = styled_components_1.default.div ``;
exports.StyledSearchWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.StyledActionButtonWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: ${({ height }) => height};
  padding: 0 ${({ theme }) => theme.sizes.s.value};
`;
exports.StyledActionButton = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.colours.support[80].value};
  text-decoration: underline;
  font-size: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-size'].value};
  font-family: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-family'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['line-height'].value};
  cursor: pointer;
  &:first-child {
    margin-right: ${({ theme }) => theme.sizes.xs.value};
  }
`;
exports.StyledMainWrapper = styled_components_1.default.div `
  width: 100%;
`;
//# sourceMappingURL=Select.styled.js.map